<template>
    <div class="team-day">
        <div class="team-day__controls">
            <v-btn icon aria-label="Giorno precedente" @click="shift(-1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-text-field ref="dayInput" v-model="day" type="date" label="Giorno" min="1900-01-01" :max="today" outlined dense hide-details="auto" :error-messages="dateError" />
            <v-btn icon :disabled="day >= today" aria-label="Giorno successivo" @click="shift(1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
            <v-btn text small :disabled="day === today" @click="day = today">Oggi</v-btn>
            <v-btn outlined small :loading="loading" @click="load">Aggiorna</v-btn>
        </div>
        <mc-state-message v-if="error" state="error" title="Giornata non disponibile" :text="error" @retry="load" />
        <mc-state-message v-else-if="loading" state="loading" title="Caricamento della giornata" />
        <template v-else-if="report">
            <p v-if="report.ore_presenza !== null" class="team-day__summary t-title-3">{{ daySummary(report) }}</p>
            <div class="team-day__metrics" aria-label="Tempi della giornata">
                <div><span class="mc-caption">Presenza conteggiata</span><strong class="t-num-md">{{ dayDurations(report).presence }}</strong></div>
                <div><span class="mc-caption">Ore lavorate</span><strong class="t-num-md">{{ dayDurations(report).work }}</strong></div>
                <div><span class="mc-caption">Tempi morti</span><strong class="t-num-md">{{ dayDurations(report).idle }}</strong></div>
                <div><span class="mc-caption">Eff. timbratura</span><strong class="t-num-md">{{ withUnit(report.efficienza, '%', 1) }}</strong></div>
            </div>
            <p class="mc-caption">Arrotondamento come nell’admin presenze: mezz’ora con tolleranza di 2 minuti. Pausa 12:00–13:00 esclusa. Intervalli fino a 5 minuti inclusi nell’attività. Le letture originali restano invariate. {{ report.provvisorio ? 'Oggi: intervalli aperti conteggiati fino ad adesso, dati provvisori.' : 'Giornata conclusa.' }}</p>
            <mc-state-message v-if="report.stato === 'non_valutabile'" state="empty" title="Giornata non valutabile" :text="report.nota" />
            <mc-state-message v-else-if="report.stato === 'assente'" state="empty" title="Assente" :text="report.nota" />
            <team-day-timeline v-else :report="report" />
            <details v-if="report.presenze.length" class="team-day__readings">
                <summary class="mc-label">Ingressi e uscite: letture e conteggio</summary>
                <ul><li v-for="(p, i) in report.presenze" :key="i">{{ clockTime(p.ingresso) }} → {{ p.uscita ? clockTime(p.uscita) : 'aperta' }} · conteggio {{ clockTime(p.inizio) }}–{{ clockTime(p.fine) }} · {{ hoursDuration(p.ore) }}</li></ul>
            </details>
            <p class="mc-caption">Aggiornato {{ updatedAt(report.aggiornato_il) }} · Persone del gruppo attualmente assegnato.</p>
        </template>
    </div>
</template>
<script>
import McStateMessage from "../../assets/mecom/vue/McStateMessage.vue";
import { withUnit, updatedAt } from "../../assets/mecom/js/format.mjs";
import TeamDayTimeline from "./TeamDayTimeline.vue";
import { dayOffset, clockTime, validDay } from "./day-model.mjs";
import { hoursDuration, daySummary, dayDurations } from "./duration-model.mjs";
export default {
    name: "TeamPersonDay",
    components: { McStateMessage, TeamDayTimeline },
    props: { person: { type: Object, required: true }, today: { type: String, required: true } },
    data() { return { day: this.today, report: null, loading: false, error: "", generation: 0 }; },
    computed: {
        dateError() { return !/^\d{4}-\d{2}-\d{2}$/.test(this.day) || this.day > this.today || this.day < "1900-01-01" ? "Scegli una data dal 1900 fino a oggi" : ""; },
    },
    watch: { day() { this.load(); } },
    mounted() { this.load(); this.$nextTick(() => this.$refs.dayInput.focus()); },
    beforeDestroy() { this.generation++; },
    methods: {
        withUnit, updatedAt, clockTime, hoursDuration, daySummary, dayDurations,
        shift(amount) { if (!this.dateError) this.day = dayOffset(this.day, amount); },
        async load() {
            const generation = ++this.generation, day = this.day, person = this.person.id;
            this.report = null; this.error = "";
            if (this.dateError) { this.loading = false; return; }
            this.loading = true;
            try {
                const response = await this.$work.get(`/teamleader/mio-team/persone/${person}/giornata/`, { giorno: day }, true);
                if (generation !== this.generation) return;
                if (!validDay(response?.data, person, day)) throw new Error("Dati incompleti");
                this.report = response.data;
            } catch (error) {
                if (generation !== this.generation) return;
                this.error = error?.response?.status === 403 ? "Persona non disponibile nel tuo gruppo." : "Impossibile caricare questa giornata. Riprova.";
            } finally { if (generation === this.generation) this.loading = false; }
        },
    },
};
</script>
